import React from "react";
export default function LoadError({ title, message, onRetry }) {
 return <section role="alert" className="rounded-2xl border border-line bg-surface-2 p-6 text-ink max-w-2xl">
  <h1 className="text-xl font-bold">{title} could not load</h1>
  <p className="mt-3 text-ink-2">{message || "Check your connection and try again."}</p>
  <button type="button" onClick={onRetry} className="mt-4 rounded-xl bg-brand px-5 py-3 font-bold text-white">Retry</button>
 </section>;
}
